import React from 'react';
import { Grid, Header, Icon, Segment } from 'semantic-ui-react';
import axios from 'axios';
// import { fadeIn, zoomIn } from 'react-animations';
// import { keyframes } from 'styled-components';
// import styled from 'styled-components';
import StudentUpcomingExams from '../StudentCoursesOverview/StudentUpcomingExams';
import { FormattedMessage } from 'react-intl';
import Announcements from "../Announcements/Announcements";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class HomePageWithAnnouncements extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div >
                <Header as="h1">
                    <FormattedMessage id="sidebar.home" />
                </Header>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">Obavještenja</Header>
                    </Segment>
                    <Segment>
                        <Announcements noSegment />
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Home/HomePageWithAnnouncements.js